import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Login } from "@/pages/Login";
import { AguardandoAutorizacao } from "@/pages/AguardandoAutorizacao";
import { Dashboard } from "@/pages/Dashboard";
import { Calendario } from "@/pages/Calendario";
import { MeusTurnos } from "@/pages/MeusTurnos";
import { Remuneracao } from "@/pages/Remuneracao";
import { Profissionais } from "@/pages/Profissionais";
import { Solicitacoes } from "@/pages/Solicitacoes";
import { Admin } from "@/pages/Admin";
import { AdminVinculos } from "@/pages/AdminVinculos";
import { Comissoes } from "@/pages/Comissoes";
import { Conferencia } from "@/pages/Conferencia";
// R1 (08/09): esqueletos do RH. As frentes seguintes preenchem exatamente
// estes arquivos — as rotas ja ficam no lugar definitivo.
import { PainelRH } from "@/pages/PainelRH";
import { Pagamentos } from "@/pages/Pagamentos";
import { Colaboradores } from "@/pages/Colaboradores";
import { Juridico } from "@/pages/Juridico";
import { MeuExtrato } from "@/pages/MeuExtrato";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/aguardando" element={<AguardandoAutorizacao />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/calendario" element={<Calendario />} />
        <Route path="/meus-turnos" element={<MeusTurnos />} />
        <Route path="/meu-extrato" element={<MeuExtrato />} />
        {/* Remuneração fica só atrás do login, sem papel exigido, DE PROPÓSITO:
            o router `remuneracao` já filtra por dono (admin vê todo mundo,
            qualquer outro papel vê apenas os próprios meses). Exigir
            financeiro aqui tiraria do veterinário a própria remuneração, que
            é justamente o que ele tem direito de ver. A trava real é no
            backend, não nesta rota. */}
        <Route path="/remuneracao" element={<Remuneracao />} />
        {/* Profissionais é CADASTRO de gente (criar, editar, vincular
            usuário): tudo lá é adminProcedure no backend. A tela ficava aberta
            a qualquer logado e mostrava o quadro inteiro antes de qualquer
            botão falhar — agora a rota casa com o backend. */}
        <Route
          path="/profissionais"
          element={
            <ProtectedRoute requireAdmin>
              <Profissionais />
            </ProtectedRoute>
          }
        />
        <Route path="/solicitacoes" element={<Solicitacoes />} />
        <Route
          path="/conferencia"
          element={
            <ProtectedRoute requireFinanceiro>
              <Conferencia />
            </ProtectedRoute>
          }
        />
        <Route
          path="/comissoes"
          element={
            <ProtectedRoute requireFinanceiro>
              <Comissoes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/painel"
          element={
            <ProtectedRoute requireFinanceiro>
              <PainelRH />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pagamentos"
          element={
            <ProtectedRoute requireFinanceiro>
              <Pagamentos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/colaboradores"
          element={
            <ProtectedRoute requireFinanceiro>
              <Colaboradores />
            </ProtectedRoute>
          }
        />
        <Route
          path="/juridico"
          element={
            <ProtectedRoute requireJuridico>
              <Juridico />
            </ProtectedRoute>
          }
        />
        {/* 24/09: /admin aceita a coordenação de escala — Admin.tsx mostra a
            ela só tipos de turno e calendário. /admin/vinculos e /profissionais
            seguem requireAdmin. */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireEscala>
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/vinculos"
          element={
            <ProtectedRoute requireAdmin>
              <AdminVinculos />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
